import { render, staticRenderFns } from "./_ProxyStoreSelectedItem.vue?vue&type=template&id=7162d92a&"
import script from "./_ProxyStoreSelectedItem.vue?vue&type=script&lang=js&"
export * from "./_ProxyStoreSelectedItem.vue?vue&type=script&lang=js&"
import style0 from "./_ProxyStoreSelectedItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports